<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("CAFETERIAS.EDIT_CAFETERIA") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <cafeteria-form
              :loading="loading"
              :cafeteriaData="cafeteria"
              :formErrors="formErrors"
              @cafeteriaSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import CafeteriaForm from "./partials/CafeteriaForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultCafeteria from "./defaultCafeteria";

export default {
  layout: "DashboardLayout",

  components: { CafeteriaForm },

  mixins: [alertLeave],

  data() {
    return {
      cafeteria: cloneDeep(defaultCafeteria),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("cafeterias/get", id);
        this.cafeteria = this.$store.getters["cafeterias/cafeteria"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List Cafeterias" });
    },

    viewCafeteria() {
      this.alertLeave = false;
      this.$router.push({
        name: "View Cafeteria",
        params: { id: this.cafeteria.id },
      });
    },

    async handleSubmit(cafeteria) {
      this.loading = true;
      const cafeteriaData = cloneDeep(cafeteria);

      try {
        await this.$store.dispatch("cafeterias/update", cafeteriaData);
        this.$notify({
          type: "success",
          message: this.$t("CAFETERIAS.CAFETERIA_UPDATED"),
        });
        this.viewCafeteria();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
